"use client";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { ReserveItem } from "../app/apis/postApis";
import InputMask, { ReactInputMask } from "react-input-mask";
import { useQueryClient } from "@tanstack/react-query";
import { fetchShopByUser, getUserByToken } from "../app/apis/getApis"; // Import the function for fetching user data
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import withModalAuth from "./auth/withModalAuth";
import { useUserStore } from "../store/User";
import { Res_btnClick } from "../UserEvents/UserEvents";
import PhoneNumberModal from "./PhoneNumberModal";
import { sendGTMEvent } from "@next/third-parties/google";
import { useParams } from "next/navigation";
const ReserveDetails = (props: any) => {
  const [validated, setValidated] = useState(false);
  const [invalidNumber, setInvaidNumber] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const { user, token, updatePhoneNumberOfUser } = useUserStore((state: any) => state);
  const params = useParams();
  const url = `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}products/${params.slug}`;


  const [initialValues, setInitialValues] = useState({
    quantity: undefined,
    note: "",
    phoneNumber: "",
  });

  const onHide = (e: any) => {
    setValidated(false);
    setInitialValues({
      quantity: undefined,
      note: "",
      phoneNumber: "",
    });
    props.onHide(e);
  };




  function convertContactNumber(number: string) {
    const phoneNumberPattern = /03(\d){9}/g;
    if (!number.match(phoneNumberPattern)) {
    } else {

      return `+92-${number.slice(1, 4)}-${number.slice(4, 12)}`;
    }
  }



  const MySwal = withReactContent(Swal);
  const mutation = useMutation({
    mutationFn: (data: any) => ReserveItem(data, token),
    onSuccess: (data, variables, context) => {
      setValidated(false);
      setInvaidNumber(false)
      updatePhoneNumberOfUser(invalidNumber ? convertContactNumber(initialValues.phoneNumber) : '');

      let shopId, shopName, listingTitle, url, listingId, price;
      if (props.reserveData.fetchedData) {
        shopId = props.reserveData.fetchedData.item.shopTable.shop_id;
        listingId = props.reserveData.fetchedData.listing_id;
        shopName = props.reserveData.fetchedData.item.shopTable.shop_name
        price = props.reserveData.fetchedData.effective_price;
        listingTitle = props.reserveData.fetchedData.item.listing_title;
        url = props.reserveData.fetchedData.url;
      } else {
        shopId = props.reserveData.shop_id;
        listingId = props.reserveData.listingId;
        listingTitle = props.reserveData.title;
        price = props.reserveData.price;
        shopName = props.reserveData.shop_name;
        url = props.reserveData.url;
      }

      sendGTMEvent({

        event: `gtm.formSubmit`,


        value: price,
        currency: 'PKR',
        items: [
          {
            item_id: listingId,
            item_name: listingTitle,
            price: price,
            shop_id: shopId,
            shop_name: shopName,
          }
        ],
        url: url,
        formType: 'reserve-form'
      })

      Swal.fire({
        title: "Request Sent Successfully!",
        html: "Request for reserve product sent !",
        icon: "success",
        showConfirmButton: false,
        timer: 5000,
      });
      setTimeout(() => {
        MySwal.close();
      }, 5000);
      onHide(undefined);
    },
    onError: (error: any) => {
      let errorMessage = ""; // Declare and initialize errorMessage
      const errorStatus = error.response.status;
      if (errorStatus === 400) {

        errorMessage = error.response.data.message[0].message.isPhoneNumber
        setInvaidNumber(true)
      }
      else if (errorStatus === 409) {
        errorMessage = error.response.data.body.message
      }
      else if (errorStatus === 500) {
        if (error.response.data.body.message.includes('Duplicate entry')) {
          errorMessage = 'This Number already Exists'
        } else {
          errorMessage = 'Something went wrong'
        }

      }

      Swal.fire({
        title: "Sorry",
        text: errorMessage,
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
      });






    },

  });



  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setInitialValues({ ...initialValues, [name]: value });
  };


  const handleSubmit = async (e: any) => {
    e.preventDefault();
    let shopId, locationId, itemId, listingId, listedQuantity;
    if (props.reserveData.fetchedData) {
      shopId = props.reserveData.fetchedData.item.shopTable.shop_id;
      locationId = props.reserveData.fetchedData.item.location_id;
      itemId = props.reserveData.fetchedData.item.item_id;
      listingId = props.reserveData.fetchedData.listing_id;
      listedQuantity = props.reserveData.fetchedData.listed_quantity;
    } else {
      shopId = props.reserveData.shop_id;
      locationId = props.reserveData.locationId;
      itemId = props.reserveData.itemId;
      listingId = props.reserveData.listingId;
      listedQuantity = props.reserveData.listedQuantity;
    }
    const obj = {
      data: {
        customer_name: user?.first_name,
        ...(user.email && { customer_email: user?.email }),
        fk_customer_id: user?.uuid,
        customer_number: initialValues.phoneNumber
          ? initialValues.phoneNumber?.replace("+92", "0")?.replace(/-/g, "")
          : user?.phone_number?.replace("+92", "0")?.replace(/-/g, ""),
        status: "Pending",
        quantity: Number(initialValues.quantity),
        shop_id: shopId,
        location_id: locationId,
        item_id: itemId,
        notes: initialValues.note,
        listing_id: listingId,
        is_customer_number_modified: invalidNumber ? true : false





      },
      token: token,
    };


    setValidated(true);
    if (
      initialValues.note.length > 4 &&
      initialValues.quantity !== undefined &&
      initialValues.quantity > 0 &&
      initialValues.quantity <= listedQuantity
    ) {
      mutation.mutate(obj);
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={onHide}
      >
        <Modal.Header closeButton>
          <Modal.Title className="py-2" id="contained-modal-title-vcenter">
            Send us reserve details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            className="p-3"
            id="reserve-form"
          >
            <Form.Group className="mb-3">
              <Form.Label className="mb-1">
                Quantity <span className="text-danger ">*</span>{" "}
              </Form.Label>
              <Form.Control
                name="quantity"
                onChange={handleChange}
                type="number"
                value={initialValues.quantity}
                required
                className="ps-3 py-2"
                placeholder="e.g. 1"
                min={1}
                max={props?.reserveData?.listedQuantity}
              />
              <Form.Control.Feedback type="invalid">
                {initialValues.quantity !== undefined && initialValues.quantity > props.reserveData?.listedQuantity
                  ? "* Not enough stock is available"
                  : "* Invalid Quantity"}
              </Form.Control.Feedback>
            </Form.Group>
            {invalidNumber && (
              <Form.Group className="mb-3">
                <Form.Label className="mb-1">
                  Phone Number <span className="text-danger ">*</span>{" "}
                </Form.Label>
                <InputMask
                  className="w-100"
                  mask="+\92399-9999999"
                  value={initialValues.phoneNumber}
                  onChange={handleChange}
                  name="phoneNumber" // Match this with Form.Control name
                >
                  <Form.Control
                    className="ps-3 py-2"
                    placeholder="xxxxxxxxxxx"
                    name="phoneNumber" // Ensure this matches with InputMask name
                    type="tel"
                    isInvalid={
                      validated &&
                      initialValues.phoneNumber.replace(/\D/g, "").length !== 12
                    }
                  />
                </InputMask>
                <Form.Control.Feedback type="invalid">
                  Invalid Phone Number
                </Form.Control.Feedback>
              </Form.Group>
            )}

            <Form.Group className="mb-3">
              <Form.Label className="mb-1">
                Reserve request details <span className="text-danger ">*</span>{" "}
              </Form.Label>
              <Form.Control
                required
                value={initialValues.note}
                name="note"
                onChange={handleChange}
                className="ps-3 py-2"
                as="textarea"
                rows={3}
                minLength={5}
                maxLength={250}
                placeholder="Enter details..."
                isInvalid={
                  validated &&
                  (initialValues.note.length <= 4 ||
                    initialValues.note.length > 249)
                }
                isValid={
                  validated &&
                  initialValues.note.length > 4 &&
                  initialValues.note.length < 249
                }
              />
              <Form.Control.Feedback type="invalid">
                * Message must be 5 to 250 characters long.
              </Form.Control.Feedback>
            </Form.Group>
            <Row className="mt-4">
              <Col>
                <Button type="submit" className="btn-primary w-100 py-2">
                  Reserve
                </Button>
              </Col>
              <Col>
                <Button
                  className="w-100 py-2 btn-outline-light"
                  onClick={onHide}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withModalAuth(ReserveDetails);
